import { localDay } from './format';

export type FollowupStatus = { label: 'Parked' | 'Overdue' | 'Soon' | 'On track'; tone: 'gray' | 'red' | 'orange' | 'green' };

// A follow-up is a calendar day in the viewer's timezone, not a UTC instant.
// Sales Dashboard, ClientView and the Fund workspace share this rule; Fund passes soonDays = 7.
export function followupStatus(followUp: string, stage = '', now = new Date(), soonDays = 3): FollowupStatus {
  if (stage === 'Non-Clients' || !/^\d{4}-\d{2}-\d{2}$/.test(followUp))
    return { label: 'Parked', tone: 'gray' };
  const today = localDay(now);
  const soon = localDay(new Date(now.getFullYear(), now.getMonth(), now.getDate() + soonDays));
  if (followUp < today) return { label: 'Overdue', tone: 'red' };
  if (followUp <= soon) return { label: 'Soon', tone: 'orange' };
  return { label: 'On track', tone: 'green' };
}
